import React, { useRef, useState } from "react";
import { api, fileUrl } from "@/lib/api";
import { UploadCloud, Loader2, X } from "lucide-react";
import { toast } from "sonner";

const MAX_IMAGES = 10;

export default function MultiImageUpload({ value = [], onChange, label, testid }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFiles = async (e) => {
    const files = Array.from(e.target.files || []).slice(0, MAX_IMAGES - value.length);
    e.target.value = "";
    if (!files.length) return;
    setUploading(true);
    try {
      const paths = [];
      for (const file of files) {
        const form = new FormData();
        form.append("file", file);
        const { data } = await api.post("/upload", form, { headers: { "Content-Type": "multipart/form-data" } });
        paths.push(data.path);
      }
      onChange([...value, ...paths]);
    } catch {
      toast.error("Upload failed");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div data-testid={testid}>
      {label && <label className="overline text-muted-foreground block mb-2">{label} ({value.length}/{MAX_IMAGES})</label>}
      <div className="grid grid-cols-3 gap-2">
        {value.map((p, i) => (
          <div key={p + i} className="relative aspect-square rounded-md overflow-hidden border border-white/10">
            <img src={fileUrl(p)} alt="" className="w-full h-full object-cover" />
            {i === 0 && <span className="absolute bottom-1 left-1 text-[10px] bg-primary px-1.5 rounded">Cover</span>}
            <button type="button" onClick={() => onChange(value.filter((_, j) => j !== i))} className="absolute top-1 right-1 bg-black/70 rounded-full p-1 hover:bg-primary">
              <X className="w-3 h-3" />
            </button>
          </div>
        ))}
        {value.length < MAX_IMAGES && (
          <button type="button" onClick={() => inputRef.current?.click()} className="aspect-square rounded-md border border-dashed border-white/20 flex flex-col items-center justify-center gap-1 text-muted-foreground hover:text-white" data-testid={`${testid}-add`}>
            {uploading ? <Loader2 className="w-5 h-5 animate-spin" /> : <UploadCloud className="w-5 h-5" />}
            <span className="text-xs">{uploading ? "Uploading" : "Add images"}</span>
          </button>
        )}
      </div>
      <input ref={inputRef} type="file" accept="image/*" multiple className="hidden" onChange={handleFiles} />
    </div>
  );
}
